import React, { useState, useEffect } from 'react'
import { APP_NAME } from "../../../../lib/constants/globalConstant";
import { redeemRewardsStyle as styles } from "../RedeemRewardsSection/redeemRewards.tailwind";
import routeConstant from "../../../../lib/constants/routeConstant";
import Button from "../../../shared/Button/Button";
import { useLocation, useNavigate } from 'react-router-dom';
import PointsDetailSection from '../RedeemRewardsSection/Sections/PointsDetailSection';
import BuyPointsModal from '../../../shared/Modals/RedeemRewardsModals/BuyPointsModal/BuyPointsModal';

const Banner = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [activeModal, setActiveModal] = useState(null);
  const handleOpenModal = (modalType) => setActiveModal(modalType);
  const handleCloseModal = () => setActiveModal(null);
  
  useEffect(() => {
    if (state && state?.openPaymentModal) {
      setActiveModal("buyPoints");
  
      // Clear the state after opening the modal
      navigate('', { replace: true, state: {} });
    }
  }, [state?.openPaymentModal, navigate]);

  return (
    <div className={styles.container}>
        <div className={styles.innerContainer}>
          <div className={styles.heading}>
            {/*FOR DEMO */}
            {/* Thank you for supporting your {APP_NAME} */}
            Your Team. Your Tokens. Real Rewards
          </div>

          {/* Buy Tokens and Points */}
          <div className={styles.button_container}>
            <Button
              variant="primaryOutlined"
              className={styles.button}
              onClick={() => navigate(routeConstant.SELECT_SPORT_PAGE)}
            >
              Buy Tokens
            </Button>
            {/*FOR DEMO */}
            {/* <Button
              variant="primaryOutlined"
              className={styles.button}
              onClick={() => handleOpenModal("buyPoints")}
            >
              Buy Points
            </Button> */}
          </div>
        </div>

        {/* Points Details (Lifetime and Available Points) */}
        <PointsDetailSection />

        {activeModal === "buyPoints" && <BuyPointsModal isOpen={true} onClose={handleCloseModal} />}
    </div>
  )
}

export default Banner